// English source strings of the D36 shell and New project flow: the collapsible navigation rail, the side assistant's
// collapsed rail, the New project choice (GitHub import or blank project) and its advanced settings, plus copy the
// i18n audit moved out of components. Merged into `en`; pt-BR lives in pt-BR-shell.ts.
export const enShell = {
  // Navigation rail (starts collapsed; expandable; pinnable)
  "nav.expand": "Expand navigation",
  "nav.collapse": "Collapse navigation",
  "nav.pin": "Keep navigation open",
  "nav.brand": "Primage Studio",

  // Side assistant rail (collapsed)
  "assistant.reopen": "Open assistant",

  // New project: choice
  "createProject.chooseDescription": "Start from a repository you already have on GitHub, or from scratch.",
  "createProject.choiceLabel": "How do you want to start?",
  "createProject.fromGithub": "Import a GitHub repository",
  "createProject.fromGithubHint": "Pick a repository from your connected GitHub: the project takes its name and default branch.",
  "createProject.fromGithubAdminOnly": "Only organization administrators can import from GitHub.",
  "createProject.blank": "Blank project",
  "createProject.blankHint": "Start empty — only a name is needed. You can connect a repository later.",
  "createProject.blankDescription": "Only the name is required; everything else has sensible defaults.",
  "createProject.noGithub": "No GitHub integration is connected yet.",
  "createProject.openIntegrations": "Connect GitHub in Integrations",
  "createProject.advanced": "Advanced settings",
  "createProject.advancedSummary": "Defaults: branch {branch} · {delivery} · {autonomy}",
  "createProject.nameExample": "For example: Inventory system",

  // Server labels shown as-is before (D36 audit)
  "projects.scopeAll": "All tasks",
  "error.network": "Could not reach the API. Check your connection and try again.",
  "error.uploadInterrupted": "The upload was interrupted. Your content was not lost; try again.",
} as const;
